import { createStore } from '@orderx/lab/xr/store';
import { AppCache, useAppCacheAutoSync } from '../../services/app-cache';
import { privacyPolicy } from './privacy-policy';
import { termsAndConditions } from './terms';

const CACHE_KEY = 'useTermsPrivacy';

interface Store {
    isAccepted: boolean;
}

const { useStore } = createStore<Store>({
    isAccepted: false,
    ...AppCache.get(CACHE_KEY),
});

export function useTermsPrivacy() {
    const [state, setState] = useStore();

    useAppCacheAutoSync(CACHE_KEY, state);

    return {
        isAccepted: state.isAccepted,
        accept() {
            setState((state) => {
                state.isAccepted = true;
            });
        },
        htmlTermsAndConditions: termsAndConditions,
        htmlPrivacyPolicy: privacyPolicy,
    };
}
